import draggable from 'vuedraggable'
draggable.name = 'AkDraggable'
export default draggable
